import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { IonTabs } from '@ionic/angular/standalone'
import { Storage } from '@ionic/storage'
import * as R from 'ramda'
import { Subject, interval } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  /**
   * 마땅히 넣을곳이 없어 여기 historyService에 꾸겨넣음
   * 다른 모듈등에서 다른 뷰나 인텐트를 사용할 시 update 조건에 걸리기 때문에 임시로 막기 위해 쓰임
   */
  updatingAvailable = true

  active$ = new Subject()

  history = {
    fabric: [],
    store: [],
    mypage: [],
  }

  tab: IonTabs
  loggerChecker$ = new Subject()

  constructor(private http: HttpClient, private storage: Storage) {
    this.setLogger()
  }

  public add([tab, name, url]: [string, string, string]) {
    if (!this.history[tab]) this.history[tab] = []
    const index = R.findIndex(v => v[2] === url, this.history[tab])
    if (index !== -1) this.history[tab] = this.history[tab].slice(0, index + 1)
    else this.history[tab].push([tab, name, url])
  }

  public setTab(tab: any) {
    this.tab = tab
  }

  public getPrevious() {
    if (!this.tab) return ''
    const tab = this.tab.getSelected()
    return R.length(this.history[tab]) > 1
      ? this.history[tab][R.length(this.history[tab]) - 2][1]
      : ''
  }

  /**
   *
   * @param category
   * @param item
   * @param throttle 캐시 유지 초(second) 서버에서 처리
   * @returns
   */
  public log(category: string, item: any, throttle: number = 0, throttleKey = '') {
    this.logs(category, item, throttle, throttleKey)
  }

  public async logs(category: string, item: any, throttle: number = 0, throttleKey = '') {
    this.loggerChecker$.next({
      category,
      item,
      throttle,
      throttleKey,
      createdAt: new Date(),
    })
  }

  public pileSearchKeyword(searchKeyword: string, category = '', position: string = '') {
    this.http.post(`/api/v2/search/keyword?search=${searchKeyword}`, {}).subscribe()
  }

  private setLogger() {
    const N = 12
    const TIME = 15000 // 15초

    const tryToSendPiledLogs = async () => {
      let howMuchOldLastLoggedAt = 0
      // 현재 쌓인 로그 가져오기
      const logs = JSON.parse(await this.storage.get('logs')) || []
      // 쌓인 로그 없으면 종료
      if (R.length(logs) === 0) return
      // 마지막으로 로깅한 시간 가져오기
      const lastLoggedAt = await this.storage.get('lastLoggedAt')
      // 로깅한 시간이 없으면 현재 시간 기록
      if (!lastLoggedAt) await this.storage.set('lastLoggedAt', new Date().getTime())
      // 로깅한 시간이 있으면 현재 시간과 계산 (마이크로초)
      if (lastLoggedAt) howMuchOldLastLoggedAt = new Date().getTime() - lastLoggedAt
      // 로그 개수가 N개 이상이거나 마지막 로그시간이 TIME만큼 지났을때 로깅 실행 후
      // 현재 로깅시간 기록
      if (R.length(logs) >= N || howMuchOldLastLoggedAt > TIME)
        this.http.post('/api/v1/logs', { logs }).subscribe(async () => {
          await this.storage.set('logs', JSON.stringify([]))
          await this.storage.set('lastLoggedAt', new Date().getTime())
        })
    }

    this.loggerChecker$.subscribe(async (data: any) => {
      if (!data) {
        tryToSendPiledLogs()
        return
      }

      const { category, item, createdAt, throttle, throttleKey } = data
      const items = JSON.parse(await this.storage.get('logs')) || []

      await this.storage.set(
        'logs',
        JSON.stringify([
          ...items,
          {
            category,
            item,
            throttle,
            throttleKey,
            createdAt,
          },
        ]),
      )
      tryToSendPiledLogs()
    })

    interval(4500).subscribe(r => {
      this.loggerChecker$.next(null)
    })
  }
}
